import React from "react";
import { BookOpen, ClipboardList, Target, CheckCircle2 } from "lucide-react";
import { Reveal, useCounter, useInView } from "../hooks";
import { PLATFORM_TOTALS, PRODUCT_STATS } from "../content";

export function StatsSection({ stats }) {
  const [ref, inView] = useInView(0.2);
  const questions = useCounter(
    stats?.practice_questions ?? PLATFORM_TOTALS.activeQuestions,
    1800,
    inView,
  );
  const mocks = useCounter(
    stats?.full_mocks ?? PLATFORM_TOTALS.fullMocks,
    1500,
    inView,
  );
  const sessionsScored = useCounter(
    PRODUCT_STATS.sessionsScoredPct,
    2000,
    inView,
  );
  const sections = useCounter(stats?.ucat_sections ?? 4, 1200, inView);
  const statItems = [
    {
      value: questions,
      suffix: "",
      label: "Active Questions",
      icon: BookOpen,
      needsApi: false,
    },
    {
      value: mocks,
      suffix: "",
      label: "Full Mocks Available",
      icon: ClipboardList,
      needsApi: false,
    },
    {
      value: sessionsScored,
      suffix: "%",
      label: "Sessions Fully Scored",
      icon: Target,
      needsApi: false,
    },
    {
      value: sections,
      suffix: "",
      label: "UCAT Sections Covered",
      icon: CheckCircle2,
      needsApi: false,
    },
  ];
  return (
    <div
      ref={ref}
      className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-border rounded-2xl overflow-hidden border border-border"
      data-testid="stats-section"
    >
      {statItems.map(({ value, suffix, label, icon: Icon, needsApi }, idx) => (
        <Reveal key={label} delay={idx * 0.1}>
          <div className="bg-card p-6 lg:p-8 flex flex-col items-center text-center gap-2">
            <div className="w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center mb-1">
              <Icon className="h-5 w-5" />
            </div>
            <div className="text-3xl lg:text-4xl font-black text-foreground font-mono tabular-nums tracking-tight">
              {needsApi && stats == null
                ? "—"
                : `${value.toLocaleString()}${suffix}`}
            </div>
            <div className="text-sm text-muted-foreground font-medium font-plex">
              {label}
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  );
}
